/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 15:09:15
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';

import { API } from '../api/api';

@Injectable({ providedIn: 'root' })
export class ResetPwdService extends BaseAjaxService {
  private admin: any = this.settings.userConfig.env.serverName.admin;

  constructor(private settings: SettingsService, http: HttpClient) {
    super(http);
  }

  /** ä¿®æ¹å¯ç  */
  updatePassword(param?): Observable<any> {
    return this.post(this.admin + API.updatePassword, param);
  }
}
